import type { FC } from 'react'

import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import Loader from '@segment/matcha/components/Loader'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { Resource } from '@segment/api/types/resource'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface ResourcesGridProps {
  resources: Omit<Resource, `featured`>[] | undefined
  isEmpty: boolean | undefined
  isLoading: boolean
  hasNextPage?: boolean
  title: string | null
  fetchNextPage: () => void
}
const ResourcesGrid: FC<ResourcesGridProps> = ({
  resources,
  isEmpty,
  isLoading,
  hasNextPage,
  title,
  fetchNextPage,
}) => {
  return (
    <CardsSection isEmpty={isEmpty} isLoading={isLoading} title={title}>
      <CardsGroup data-testid="loading-overlay" aria-live="polite" aria-busy={isLoading}>
        {resources?.map(({ ...props }, key) => (
          <Card key={key} {...props} />
        ))}
        {isEmpty && (
          <CopyTextBase>
            <CopyText.Description variant="pMedium">Oops! No resources match your criteria.</CopyText.Description>
          </CopyTextBase>
        )}
      </CardsGroup>
      {isLoading && (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      )}
      {hasNextPage && (
        <ButtonWrapper>
          <ButtonText onClick={fetchNextPage} iconEnd={ChevronRightIcon}>
            Load more
          </ButtonText>
        </ButtonWrapper>
      )}
    </CardsSection>
  )
}

const ButtonWrapper = styled.div`
  text-align: center;
  padding: 48px 0;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 0;
  }
`

const LoaderWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  margin: 0 auto;
`

export default ResourcesGrid
